<template>
  <section class="interface">
    <Profile/>
    <section class="title">
      <h1><i class="icon-statistique"></i>STATISTIQUES</h1>
    </section>

    <StatisticsPartner />

    <StatisticsProgram />

    <StatisticsPrograms />

  </section>
</template>

<script>
import Profile from '@/components/Profile.vue'
import StatisticsPartner from '@/components/StatisticsPartner.vue'
import StatisticsPrograms from '@/components/StatisticsPrograms.vue'
import StatisticsProgram from '@/components/StatisticsProgram.vue'

export default {
  name: 'Statistics',
  components: {
    Profile,
    StatisticsPartner,
    StatisticsPrograms,
    StatisticsProgram
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>
